import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import getEventSource from '../../services/getEventSource';
var VERSION = '1.1';
var CONTROL_CHANNEL_REGEX = /^control_/;

var SSEClient = /*#__PURE__*/function () {
  // Instance properties:
  //  streamingUrl: string
  //  EventSource: EventSource constructor
  //  connection: EventSource | undefined
  //  handler: EventHandler for open, close, error and messages events
  //  authToken: Object | undefined
  function SSEClient(EventSource, settings) {
    _classCallCheck(this, SSEClient);

    this.EventSource = EventSource;
    this.streamingUrl = settings.url('/sse');
    this.reopen = this.reopen.bind(this);
  }

  _createClass(SSEClient, [{
    key: "setEventHandler",
    value: function setEventHandler(handler) {
      this.handler = handler;
    }
    /**
     * Open the connection with a given authToken
     *
     * @param {Object} authToken
     * @throws {TypeError} if `authToken` is undefined
     */

  }, {
    key: "open",
    value: function open(authToken) {
      this.close(); // it closes connection if previously opened

      this.authToken = authToken;
      var channelsQueryParam = Object.keys(authToken.channels).map(function (channel) {
        var params = CONTROL_CHANNEL_REGEX.test(channel) ? '[?occupancy=metrics.publishers]' : '';
        return encodeURIComponent(params + channel);
      }).join(',');
      var url = "".concat(this.streamingUrl, "?channels=").concat(channelsQueryParam, "&accessToken=").concat(authToken.token, "&v=").concat(VERSION, "&heartbeats=true"); // same results using `&heartbeats=false`

      this.connection = new this.EventSource(url);

      if (this.handler) {
        // no need to check if SSEClient is used only by PushManager
        this.connection.onopen = this.handler.handleOpen;
        this.connection.onmessage = this.handler.handleMessage;
        this.connection.onerror = this.handler.handleError;
      }
    }
    /** Close connection  */

  }, {
    key: "close",
    value: function close() {
      if (this.connection) this.connection.close();
    }
    /**
     * Re-open the connection with the last given authToken.
     *
     * @throws {TypeError} if `open` has not been previously called with an authToken
     */

  }, {
    key: "reopen",
    value: function reopen() {
      this.open(this.authToken);
    }
  }], [{
    key: "getInstance",
    value:
    /**
     * Returns a SSEClient instance, or undefined if EventSource is not available.
     * @param {*} settings Split settings used to get streaming URL
     */
    function getInstance(settings) {
      var EventSource = getEventSource();
      if (EventSource) return new SSEClient(EventSource, settings);
    }
  }]);

  return SSEClient;
}();

export { SSEClient as default };